import { getSMPTETimecode } from '@/components/Packaging/utils';
import { useAppSelector } from '@/redux/hooks';
import { selectPackagingTimelineFrameRate } from '@/redux/selectors/packagingSelectors';
import { selectTimelineFramesCount } from '@/redux/selectors/packagingTimelineSelectors';
import styled from '@emotion/styled';
import { Container, Typography } from '@mui/material';
import { ReactNode } from 'react';
import PolarisIcon from '../_common/PolarisIcon';
import SlideToggle from '../_common/SlideToggle';
import { PackagingViewTypes } from './Packaging';

interface PosterLineProps {
  toggleView: (view: PackagingViewTypes) => void;
  children: ReactNode;
}

const TimelineViewManager = ({ toggleView, children }: PosterLineProps) => {
  const timelineFramesCount = useAppSelector(selectTimelineFramesCount);
  const frameRate = useAppSelector(selectPackagingTimelineFrameRate);

  return (
    <Wrapper>
      <LeftSide>
        {children}
      </LeftSide>
      <RightSide>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <PolarisIcon icon="timer_outline" height={20} />
          <Typography variant="h6" sx={{ paddingLeft: 1 }}>
            Total Duration
          </Typography>
          <Duration>{getSMPTETimecode(timelineFramesCount, frameRate)}</Duration>
        </div>
        <div>
          <SlideToggle
            left={{ label: 'Timeline View', value: PackagingViewTypes.TIMELINE }}
            right={{ label: 'List View', value: PackagingViewTypes.LIST }}
            callback={(value) => {
              if (typeof value === 'string' && Object.values(PackagingViewTypes).includes(value as PackagingViewTypes)) {
                toggleView(value as PackagingViewTypes);
              }
            }}
            alternateColors
            defaultUnchecked
          />
        </div>
      </RightSide>
    </Wrapper>
  );
};

export default TimelineViewManager;

const Wrapper = styled(Container)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: ${({ theme }) => theme.spacing(0, 4, 3, 4)};
  height: 140px;
`;

const LeftSide = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: ${({ theme }) => theme.spacing(3)};
  height: 100%;
  flex-grow: 2;
  `;

const RightSide = styled.div`
  height: 100%;
  width: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Duration = styled.span`
  font-size: 1.5rem;
  margin-left: ${({ theme }) => theme.spacing(1)};
`;
